import { toast } from 'sonner';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { useChangeRole } from '@/hooks/use-users';
import type { AdminUser } from '@/types/users';

interface ChangeRoleDialogProps {
  user: AdminUser;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChangeRoleDialog({ user, open, onOpenChange }: ChangeRoleDialogProps): JSX.Element {
  const changeRole = useChangeRole();
  const nextRole = user.role === 'admin' ? 'user' : 'admin';
  const label = nextRole === 'admin' ? 'Admin' : 'User';
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={`Make ${user.name} ${nextRole === 'admin' ? 'an' : 'a'} ${label}?`}
      body={
        nextRole === 'admin'
          ? 'Admins can manage users, invites and projects and see everyone’s time.'
          : 'They lose access to Admin pages on their next request.'
      }
      confirmLabel={`Make ${label}`}
      pending={changeRole.isPending}
      onConfirm={() =>
        changeRole.mutate(
          { id: user.id, role: nextRole },
          {
            onSuccess: () => {
              toast.success(`${user.name} is now ${nextRole === 'admin' ? 'an' : 'a'} ${label}.`);
              onOpenChange(false);
            },
            onError: () => onOpenChange(false),
          },
        )
      }
    />
  );
}
